import * as ng from 'angular';
import {ArchiSmallServices} from '../../../../services/archismall.service';
import {IDocToConserveStatistics} from '../../../../commons/interfaces/IDocToConserveStatistics';
import {FileService} from '../../../../services/file.service';

class DocumentiDaConservareController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    'ArchiSmallServices',
    '$uibModal',
    '$state',
    'FileService',
  ];

  constructor(
    private $scope: {
      docsToConserve: IDocToConserveStatistics[];
      documentsId: string[];
      label: string[];
      colours: string[];
      valueStatusDocs: number[];
      keyStausDocs: string[];
      objStatusDocs: { [key: number]: number };
      objDocIds: { [key: number]: string[] };
      user: IDocToConserveStatistics;

      // serve per evitare errori di typescript su parametri non definiti, di default ogni parametro è any
      [key: string]: any
    },
    private $rootScope: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private $state: any,
    private fileService: FileService,
  ) {
    $scope.pageHeader = 'Stato procedura conservazione';

    $scope.loadData = async () => {
      try {
        // dimensione di ogni blocco di elaborazione
        const batchSize = 1000;
        const response = await ArchiSmallServices.getDocToConserveStatisticsItems();
        $scope.docsToConserve = JSON.parse(JSON.stringify(response));

        $scope.objStatusDocs = {1: 0, 2: 0, 7: 0, 10: 0};
        $scope.objDocIds = {1: [], 2: [], 7: [], 10: []};
        $scope.valueStatusDocs = [0, 0, 0, 0];
        const processBatch = (batch: any[]) => {
          batch
            .sort((a, b) => a.status - b.status)
            .forEach((value) => {
              $scope.objStatusDocs[value.status] = ($scope.objStatusDocs[value.status] || 0) + value.count;
              $scope.valueStatusDocs = [
                $scope.objStatusDocs[1] || 0,
                $scope.objStatusDocs[2] || 0,
                $scope.objStatusDocs[7] || 0,
                $scope.objStatusDocs[10] || 0,
              ];
              $scope.objDocIds[value.status] = $scope.objDocIds[value.status].concat(value.docIds);
            });
        };

        // elaborazione a blocchi per evitare stack overflow
        for (let i = 0; i < $scope.docsToConserve.length; i += batchSize) {
          const batch = $scope.docsToConserve.slice(i, i + batchSize);
          processBatch(batch);
        }

        $scope.label = ['In coda', 'Conservati', 'In errore', 'Da conservare'];
        $scope.colours = ['#2B77BA', '#4cae4c', '#FF0000', '#FFC107'];
        $scope.consumiData = [
          {class: 'in-coda-bgrd', label: 'In coda', status: $scope.valueStatusDocs[0]},
          {class: 'conservati-bgrd', label: 'Conservati', status: $scope.valueStatusDocs[1]},
          {class: 'in-errore-bgrd', label: 'In errore', status: $scope.valueStatusDocs[2]},
          {class: 'da-conservare-bgrd', label: 'Da conservare', status: $scope.valueStatusDocs[3]},
        ];
        $scope.$apply();

        $scope.options = {
          onClick: function (event, elements) {
            if (!elements.length) {
              return;
            }
            const mapping = [1, 2, 7, 10];
            const index = mapping[elements[0]._index];
            $scope.viewDocumentIds($scope.objDocIds[index]);
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                const label = data.labels[tooltipItem.index] || '';
                const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                return `${value} documents`;
              }
            }
          }
        };
      } catch (error) {
        console.error('Errore durante il caricamento dei dati:', error);
      }
    };

    $scope.loadData();


    $scope.fieldUser = () => {
      $scope.user = JSON.parse($scope.selectUser);
    };

    $scope.viewDocumentIds = (listIds: string[]) => {
      const documentsId = listIds;
      let CreateModal = $uibModal.open({
        animation: true,
        component: 'viewDocIdDocumentModalComponent',
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          documentsId: () => {
            return documentsId;
          },
        }
      });
      CreateModal.result
        .catch(error => {
          console.error('Error:', error);
        })
        .finally(() => {
          $state.reload();
        });
    };

    $scope.exportCsv = () => {
      let CreateModal = $uibModal.open({
        animation: true,
        component: 'workerDownloadCsvClientiModalComponent',
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          settings: {
            user: $rootScope.currentUser().sub,
            key: 'exportCsvData',
          }
        }
      });
      CreateModal.result.catch(error => {
        console.error('Error:', error);
      })
        .finally(() => {
          $state.reload();
        });
    };

  }
}

export const DocumentiDaConservareComponent: ng.IComponentOptions = {
  template: require('./documenti-da-conservare.html'),
  controller: DocumentiDaConservareController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/documenti-da-conservare/documenti-da-conservare.ts